/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ProcessingState } from "./ProcessingState";
import {
  ProcessingStateFromJSON,
  ProcessingStateFromJSONTyped,
  ProcessingStateToJSON,
  ProcessingStateToJSONTyped,
} from "./ProcessingState";

/**
 *
 * @export
 * @interface QuoteGroup
 */
export interface QuoteGroup {
  /**
   *
   * @type {string}
   * @memberof QuoteGroup
   */
  quoteGroupId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteGroup
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteGroup
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGroup
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof QuoteGroup
   */
  isInitialQuoteGroup?: boolean;
  /**
   *
   * @type {ProcessingState}
   * @memberof QuoteGroup
   */
  state?: ProcessingState;
  /**
   *
   * @type {string}
   * @memberof QuoteGroup
   */
  experimentRunId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGroup
   */
  errorMessage?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteGroup
   */
  startedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteGroup
   */
  completedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the QuoteGroup interface.
 */
export function instanceOfQuoteGroup(value: object): value is QuoteGroup {
  return true;
}

export function QuoteGroupFromJSON(json: any): QuoteGroup {
  return QuoteGroupFromJSONTyped(json, false);
}

export function QuoteGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteGroup {
  if (json == null) {
    return json;
  }
  return {
    quoteGroupId:
      json["quoteGroupId"] == null ? undefined : json["quoteGroupId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    name: json["name"] == null ? undefined : json["name"],
    isInitialQuoteGroup:
      json["isInitialQuoteGroup"] == null
        ? undefined
        : json["isInitialQuoteGroup"],
    state:
      json["state"] == null
        ? undefined
        : ProcessingStateFromJSON(json["state"]),
    experimentRunId:
      json["experimentRunId"] == null ? undefined : json["experimentRunId"],
    errorMessage:
      json["errorMessage"] == null ? undefined : json["errorMessage"],
    startedAt: json["startedAt"] == null ? undefined : json["startedAt"],
    completedAt: json["completedAt"] == null ? undefined : json["completedAt"],
  };
}

export function QuoteGroupToJSON(json: any): QuoteGroup {
  return QuoteGroupToJSONTyped(json, false);
}

export function QuoteGroupToJSONTyped(
  value?: QuoteGroup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quoteGroupId: value["quoteGroupId"],
    createdAt: value["createdAt"],
    shipmentId: value["shipmentId"],
    name: value["name"],
    isInitialQuoteGroup: value["isInitialQuoteGroup"],
    state: ProcessingStateToJSON(value["state"]),
    experimentRunId: value["experimentRunId"],
    errorMessage: value["errorMessage"],
    startedAt: value["startedAt"],
    completedAt: value["completedAt"],
  };
}
